<template>
  <div>
    <div class="container body-company-container">
      <popup />
      <flash-message />
      <template v-if="!dataHasLoaded">
        <!-- Data is loading, please wait... -->
      </template>
      <template v-else>
        <div class="row reportHeader" id="top">
          <div class="col-xs-6">
            <h1>{{ companyData.company_name }}</h1>
          </div>
          <div class="col-xs-6 text-right header-action-buttons">
            <button @click="onClickRunReport" class="btn btn-runReport btn-lg pull-right">
              Run New Report &gt;
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <company-heading :company-overview="companyData" />
            <overview :company-overview="companyData" />
          </div>
        </div>
        <div class="reportSection">
          <div class="row">
            <div class="col-xs-6">
              <section-heading>
                <div slot="title">Reports</div>
              </section-heading>
            </div>
            <div class="col-xs-6 text-right header-action-buttons">
              <button @click="onClickRunReport" class="btn btn-runReport btn-lg pull-right">
                Run New Report &gt;
              </button>
            </div>
          </div>
        </div>
        <div class="row">
          <reports-table :company-overview="companyData" />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import SectionHeading from '@/components/companies/components/SectionHeading';
import FlashMessage from '@/components/tools/FlashMessage';
import Popup from '@/components/tools/Popup';
import CompanyMixin from '@/mixins/Company';
import Axios from '@/packages/axios/Axios';
import { mapGetters } from 'vuex';
import CompanyHeading from './components/CompanyHeading';
import ReportsTable from './reportsindex/Table';
import Overview from './sections/overview/Overview';

export default {
  components: {
    CompanyHeading,
    FlashMessage,
    Overview,
    Popup,
    ReportsTable,
    SectionHeading,
  },
  computed: {
    ...mapGetters(['client']),
  },
  created() {
    this.loadData();
  },
  data() {
    return {
      dataHasLoaded: false,
    };
  },
  methods: {
    loadData() {
      this.dataHasLoaded = false;
      this.loadCompanyData().then(() => {
        this.dataHasLoaded = true;
      });
    },
    onClickRunReport() {
      Axios.post(`/v1/reports/${this.companyData.company.id}`)
        .then(() => {
          this.$router.push('/reports/create');
        })
        .catch((e) => {
          if (e.response) {
            switch (e.response.status) {
              case 401:
                this.$router.push('/error/401');
                break;
              case 403:
                this.$router.push('/error/403');
                break;
              case 404:
                this.$router.push('/error/404');
                break;
              default:
                this.$router.push('/error/unknown');
            }
          }
        });
    },
  },
  mixins: [CompanyMixin],
};
</script>

<style scoped>
.body-company-container {
  padding-top: 120px;
  padding-bottom: 140px;
}

.header-action-buttons {
  margin-top: 20px;
}

.accordion-toggle:after {
  font-family: 'Glyphicons Halflings';
  margin-top: 2px;
  margin-left: 5px;
  content: '\E114';
  float: right;
  color: grey;
}

.accordion-toggle.collapsed:after {
  content: '\e080';
}

.info {
  background-color: #d8d8f1;
  padding-left: 10px;
  padding-top: 5px;
  padding-bottom: 5px;
}
</style>
